// extracted by mini-css-extract-plugin
module.exports = {"title":"step-by-step-module_title__eTFPf","cards":"step-by-step-module_cards__bHwZP"};